import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import StepIndicator from './StepIndicator';
import FormInput from '../common/FormInput';
import MainLayout from '../common/MainLayout';

function PaymentDetails() {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [touched, setTouched] = useState({});
  const [errors] = useState({});

  const handleBlur = e => {
    const { name } = e.target;
    setTouched(prev => ({
      ...prev,
      [name]: true,
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    navigate('/membership/review');
  };

  return (
    <MainLayout>
      <StepIndicator currentStep={4} />

      <h2 className="text-2xl font-bold mb-8 text-hdlcc-textPrimary tracking-tight">
        Payment Details
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-bold text-hdlcc-textPrimary mb-4">Payment Method</h3>
            <div className="space-y-3">
              <label
                className={`flex items-center space-x-3 p-4 rounded-xl cursor-pointer border-2 transition-all duration-200 shadow-elevation-1 ${
                  paymentMethod === 'card'
                    ? 'border-hdlcc-primary bg-gradient-to-br from-hdlcc-mediumGray to-hdlcc-gray shadow-glow-primary'
                    : 'border-hdlcc-lightGray/20 bg-hdlcc-mediumGray hover:border-hdlcc-primary/50 hover:shadow-elevation-2'
                }`}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value="card"
                  checked={paymentMethod === 'card'}
                  onChange={e => setPaymentMethod(e.target.value)}
                  className="text-hdlcc-primary focus:ring-hdlcc-primary"
                />
                <span className="text-hdlcc-textPrimary font-medium">Credit/Debit Card</span>
              </label>
              <label
                className={`flex items-center space-x-3 p-4 rounded-xl cursor-pointer border-2 transition-all duration-200 shadow-elevation-1 ${
                  paymentMethod === 'direct-debit'
                    ? 'border-hdlcc-primary bg-gradient-to-br from-hdlcc-mediumGray to-hdlcc-gray shadow-glow-primary'
                    : 'border-hdlcc-lightGray/20 bg-hdlcc-mediumGray hover:border-hdlcc-primary/50 hover:shadow-elevation-2'
                }`}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value="direct-debit"
                  checked={paymentMethod === 'direct-debit'}
                  onChange={e => setPaymentMethod(e.target.value)}
                  className="text-hdlcc-primary focus:ring-hdlcc-primary"
                />
                <span className="text-hdlcc-textPrimary font-medium">Direct Debit</span>
              </label>
            </div>
          </div>

          {paymentMethod === 'card' && (
            <div className="space-y-6">
              <FormInput
                label="Card Number"
                name="cardNumber"
                placeholder="1234 5678 9012 3456"
                onBlur={handleBlur}
                error={errors.cardNumber}
                touched={touched.cardNumber}
              />

              <div className="grid grid-cols-2 gap-6">
                <FormInput
                  label="Expiry Date"
                  name="expiryDate"
                  placeholder="MM/YY"
                  onBlur={handleBlur}
                  error={errors.expiryDate}
                  touched={touched.expiryDate}
                />
                <FormInput
                  label="CVV"
                  name="cvv"
                  placeholder="123"
                  onBlur={handleBlur}
                  error={errors.cvv}
                  touched={touched.cvv}
                />
              </div>
            </div>
          )}

          {paymentMethod === 'direct-debit' && (
            <div className="space-y-6">
              <FormInput
                label="Account Name"
                name="accountName"
                onBlur={handleBlur}
                error={errors.accountName}
                touched={touched.accountName}
              />

              <div className="grid grid-cols-2 gap-6">
                <FormInput
                  label="Sort Code"
                  name="sortCode"
                  placeholder="00-00-00"
                  onBlur={handleBlur}
                  error={errors.sortCode}
                  touched={touched.sortCode}
                />
                <FormInput
                  label="Account Number"
                  name="accountNumber"
                  placeholder="12345678"
                  onBlur={handleBlur}
                  error={errors.accountNumber}
                  touched={touched.accountNumber}
                />
              </div>
            </div>
          )}
        </div>

        <div className="mt-8 flex justify-between">
          <button
            type="button"
            onClick={() => navigate('/membership/type')}
            className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 text-white px-8 py-3 rounded-xl hover:bg-hdlcc-gray transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Previous
          </button>
          <button
            type="submit"
            className="bg-gradient-to-r from-hdlcc-primary to-hdlcc-primaryLight text-white px-8 py-3 rounded-xl hover:shadow-glow-primary transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Next: Review Details
          </button>
        </div>
      </form>
    </MainLayout>
  );
}

export default PaymentDetails;
